import { withLoading } from "hocs/withLoading";
import { lazy } from "react";

export const BlockChatPopup = withLoading(
  lazy(() => import("./BlockChatPopup"))
);
